import { render, staticRenderFns } from "./PaymentMethodResolver.vue?vue&type=template&id=64846570&scoped=true&"
import script from "./PaymentMethodResolver.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64846570",
  null
  
)

export default component.exports